import React from "react";
import CheckUsOutComponent from "../../components/Checkusout/";
import NavComponent from "../../components/Nav";
import FooterComponent from "../../components/Footer";

export interface AboutComponentProps {
  aboutPageData: any; // Add proper type definition
  error?: any;
  isLoading?: boolean;
}

export const AboutContentPiece: React.FC<AboutComponentProps> = ({
  aboutPageData,
  error,
  isLoading,
}) => {
  return (
    <div className="min-h-screen bg-sow-black mx-auto pt-24 sm:pt-20">
      {isLoading && (
        <div className="flex items-center justify-center h-screen text-sow-white">
          <div className="animate-pulse text-center">
            <p className="text-lg font-semibold mb-2">Loading story…</p>
            <p className="text-sm opacity-75">Fetching about page data</p>
          </div>
        </div>
      )}
      {!isLoading && error && (
        <div className="flex flex-col items-center justify-center h-screen text-center px-6">
          <h1 className="text-2xl font-bold text-red-400 mb-4">
            Unable to load about page
          </h1>
          <p className="text-sow-white/80 max-w-md">
            We hit a snag loading this page. Please refresh or try again later.
          </p>
        </div>
      )}
      {!isLoading && !error && aboutPageData && (
        <>
          {/* Fixed Nav with responsive repositioning */}
          <div className="sow-fixed-navigation fixed top-4 left-1/2 -translate-x-1/2 z-40 sm:top-6 sm:left-6 sm:translate-x-0 lg:top-8 lg:left-8">
            <NavComponent />
          </div>
          {/* Mobile spacer for fixed nav height */}
          <div className="block sm:hidden h-2" aria-hidden="true" />
          {aboutPageData?.checkUsOut?.visible !== false && (
            <CheckUsOutComponent
              imgTopSrc={aboutPageData?.checkUsOut?.firstImg}
              imgTopAlt={aboutPageData?.checkUsOut?.firstAlt || ""}
              imgMiddleSrc={aboutPageData?.checkUsOut?.thirdImg}
              imgMiddleAlt={
                aboutPageData?.checkUsOut?.thirdAlt ||
                "Friends dining on the patio"
              }
              imgBottomSrc={aboutPageData?.checkUsOut?.secondImg}
              imgBottomAlt={
                aboutPageData?.checkUsOut?.secondAlt ||
                "Friends dining on the patio"
              }
              imgVideoSrc={aboutPageData?.meetTheOwners}
              title={aboutPageData?.checkUsOut?.title}
              copy={aboutPageData?.checkUsOut?.content}
              variant={"horizontal"}
              showBubbles={true}
              bubbleAnimation={"float"}
              reverse={true}
              slideInVariant={"displace-lite"}
            />
          )}
          <hr className="mt-16 sm:mt-20 lg:mt-24 mb-16 sm:mb-20 lg:mb-24 border-sow-gold" />
          {aboutPageData?.whatOurGuestsSay?.visible !== false && (
            <CheckUsOutComponent
              imgTopSrc={aboutPageData?.whatOurGuestsSay?.firstImg}
              imgTopAlt={
                aboutPageData?.whatOurGuestsSay?.firstAlt ||
                "Guest enjoying a cocktail"
              }
              imgMiddleSrc={aboutPageData?.whatOurGuestsSay?.thirdImg}
              imgMiddleAlt={
                aboutPageData?.whatOurGuestsSay?.thirdAlt ||
                "Friends dining on the patio"
              }
              imgBottomSrc={aboutPageData?.whatOurGuestsSay?.secondImg}
              imgBottomAlt={
                aboutPageData?.whatOurGuestsSay?.secondAlt ||
                "Friends dining on the patio"
              }
              title={aboutPageData?.whatOurGuestsSay?.title}
              copy={aboutPageData?.whatOurGuestsSay?.content}
              variant={"tiered"}
              showBubbles={true}
              bubbleAnimation={"float"}
              reverse={false}
              backgroundImg={aboutPageData?.bkgImg}
            />
          )}
          <FooterComponent
            imageUrl={aboutPageData?.sowLogo}
            backgroundUrl={aboutPageData?.bkgImg}
          />
        </>
      )}
    </div>
  );
};
